var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1 mt-4",attrs:{"headers":_vm.headers,"items":_vm.casesWithCompanies,"items-per-page":5,"sort-by":['ID']},scopedSlots:_vm._u([{key:"item.Actions",fn:function(ref){
var item = ref.item;
var value = ref.value;
return [_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openCase(item)}}},[_vm._v("Open")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }